import { useState } from "react";

interface ReadMoreProps {
  id?: string;
  text: string;
  amountOfWords?: number;
  className?: string;
}

export const ReadMore = ({
  id,
  text,
  amountOfWords = 30,
  className = "",
}: ReadMoreProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const splittedText = text.split(" ");
  const itCanOverflow = splittedText.length > amountOfWords;
  const beginText = itCanOverflow
    ? splittedText.slice(0, amountOfWords - 1).join(" ")
    : text;
  const endText = splittedText.slice(amountOfWords - 1).join(" ");

  const handleKeyboard = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.code === "Space" || e.code === "Enter") {
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <p id={id} className={`p-2 ${className}`}>
      {beginText}
      {itCanOverflow && (
        <>
          {isExpanded ? <span> </span> : <span>... </span>}
          <span
            className={`${!isExpanded && "hidden"}`}
            aria-hidden={!isExpanded}
          >
            {endText}
          </span>
          <span
            className={`font-semibold text-nowrap`}
            role="button"
            tabIndex={0}
            aria-expanded={isExpanded}
            aria-controls={id}
            onKeyDown={handleKeyboard}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? " show less" : " show more"}
          </span>
        </>
      )}
    </p>
  );
};
